import {Checkpoint} from "../../entities/Checkpoint";
import {Addressbook} from "../../entities/Addressbook";
import {Tracedo} from "../../entities/Tracedo";
import {PoItem} from "../../entities/PoItem";

export enum CheckpointFactoryCheckpointType {
    RailLoad = 3,
    RailUnload= 4
}

export class CheckpointFactory {

    static makeCheckpoint(typeId?: CheckpointFactoryCheckpointType, name?: string): Checkpoint {
        return {
            typeId: typeId,
            addressName: '',
            addressStreet: '',
            addressStreet2: '',
            addressTown: '',
            addressZipCode: '',
            addressCountryId: null,
            addressbookId: null,
            ata: null,
            atd: null,
            contactEmail: '',
            contactFirstName: '',
            contactId: null,
            contactLastName: '',
            contactPhone: '',
            eta: null,
            etd: null,
            name: name,
            note: '',
            reference: '',
            // Colli / Po Items for checkpoint
            kgs: null,
            colliTypeId: null,
            colli: null,
            poItems: [],
            ramp: {"id": null, "name": null},
            rampId: null,
            rampName: null,
        };
    }

    static makeCheckpointWithAddress(address?: Addressbook, typeId?: CheckpointFactoryCheckpointType, name: string = ''): Checkpoint {
        let checkpoint = this.makeCheckpoint(typeId, name);
        checkpoint.id = null;
        if (address === null) return checkpoint;
        this.checkpointSetAddress(address, checkpoint);
        return checkpoint;
    }

    static checkpointSetAddress(address:Addressbook, checkpoint: Checkpoint): Checkpoint {
        checkpoint.addressbook = address;
        checkpoint.addressbookId = address.addressbookId;
        checkpoint.addressCountryId = address.countryId;
        checkpoint.addressName = address.name;
        checkpoint.addressCountry = address.country;
        checkpoint.addressStreet = address.street;
        checkpoint.addressStreet2 = address.street2;
        checkpoint.addressTown = address.town;
        checkpoint.addressZipCode = address.zipCode;
        return checkpoint;
        checkpoint.addressFull = address.web;

    }

    static makeOriginCheckpoint(tracedo: Tracedo, originPoItems: number[]): Checkpoint {
        return {
            typeId: null,
            addressName: tracedo.originAddressName,
            addressStreet: tracedo.originAddressStreet,
            addressStreet2: tracedo.originAddressStreet2,
            addressTown: tracedo.originAddressCity,
            addressZipCode: tracedo.originAddressZipCode,
            addressCountryId: tracedo.originAddressCountryId,
            addressbookId: tracedo.pickupAddressId,
            atd: tracedo.atd,
            contactEmail: tracedo.originContactEmail,
            contactFirstName: tracedo.originContactFirstName,
            contactId: tracedo.pickupContactId,
            contactLastName: tracedo.originContactLastName,
            contactPhone: tracedo.originContactPhone,
            etdFrom: tracedo.etdFrom,
            etdTo: tracedo.etdTo,
            atdReady: tracedo.atdReady,
            name: 'Origin',
            note: tracedo.originNote,
            reference: tracedo.loadingReference,
            colli: tracedo.originColli,
            kgs: tracedo.originKgs,
            colliTypeId: tracedo.originColliTypeId,
            poItems: originPoItems,
            ramp: tracedo.originRamp,
            rampId: tracedo.originRampId,
            rampName: tracedo.originRampName,
        }
    }

    static makeDestinationCheckpoint(tracedo: Tracedo, destinationPoItems: number[]): Checkpoint {
        return {
            typeId: null,
            addressName: tracedo.destAddressName,
            addressStreet: tracedo.destAddressStreet,
            addressStreet2: tracedo.destAddressStreet2,
            addressTown: tracedo.destAddressCity,
            addressZipCode: tracedo.destAddressZipCode,
            addressCountryId: tracedo.destAddressCountryId,
            addressbookId: tracedo.deliveryAddressId,
            ata: tracedo.ata,
            contactEmail: tracedo.destinationContactEmail,
            contactFirstName: tracedo.destinationContactFirstName,
            contactId: tracedo.deliveryContactId,
            contactLastName: tracedo.destinationContactLastName,
            contactPhone: tracedo.destinationContactPhone,
            etaFrom: tracedo.etaFrom,
            etaTo: tracedo.etaTo,
            ataReady: tracedo.ataReady,
            name: 'Destination',
            note: tracedo.destinationNote,
            reference: tracedo.unloadingReference,
            colli: tracedo.destinationColli,
            kgs: tracedo.destinationKgs,
            colliTypeId: tracedo.destinationColliTypeId,
            poItems: destinationPoItems,
            ramp: tracedo.destinationRamp,
            rampId: tracedo.destinationRampId,
            rampName: tracedo.destinationRampName,
        }
    }
}